module.exports = __webpack_public_path__ + "img/schedule_sp.112c64ec.svg";